import React, { useMemo } from "react";
import { Table, Headings } from "@sentara-health/optimahealth_web";
import { convertToDate, useExtractClaimTotals, formatAmount } from "common";
import { ClaimResponse } from "@sentara-health/sentara-api-hooks-core";
import { useTranslation } from "react-i18next";

interface ClaimsBreakDownTableProps {
  claimData: ClaimResponse;
}

const ClaimsBreakDownTable: React.FC<ClaimsBreakDownTableProps> = ({
  claimData,
}) => {

  const { t } = useTranslation();
  const totals = useExtractClaimTotals(claimData)

  const rows = useMemo(() => {
    if (!totals) return [];

    return [
      [
        {
          text: (
            <th scope="col">{t("common.totalCharges")}</th>
          )
        },
        { text: `$${totals.totalCharges}` },
      ],
      [
        {
          text: (
            <th scope="col">{t("common.totalNotCovered")}</th>
          )
        },
        { text: `$${totals.totalNotCovered}` },
      ],
      [
        {
          text: (
            <th scope="col">{t("common.totalCovered")}</th>
          )
        },
        { text: `$${totals.totalCovered}` },
      ],
      [
        {
          text: (
            <th scope="col">{t("common.totalDeductible")}</th>
          )
        },
        { text: `$${totals.totalDeductible}` },
      ],
      [
        {
          text: (
            <th scope="col">{t("common.totalCopayCoinsurance")}</th>
          )
        },
        {
          text: `$${formatAmount(totals.copayPlusCoinsurance)}`,
        },
      ],
      [
        {
          text: (
            <th scope="col">{t("common.totalPaidByPlan")}</th>
          )
        },
        { text: `$${totals.totalPaidByPlan}` },
      ],
      [
        {
          text: (
            <th scope="col">{t("claimsSummary.patientResponsibility")}</th>
          )
        },
        { text: `$${totals.patientResponsibility}` },
      ],
      [
        {
          text: (
            <th scope="col">{t("claimsSummary.datePaymentSentToProvider")}</th>
          )
        },
        { text: totals.datePaymentSentToProvider ? convertToDate(totals.datePaymentSentToProvider) : "-" },
      ],
    ];
  }, [totals]);

  const header = [
    { text: "Details" },
    { text: "Amount" },
  ];

  return (
    <div className="mb-5 print">
      <Headings level={3} text={t("claimsSummary.claimsBreakdown")} variant="semiBold" className="mb-4" />
      <Table
        header={header}
        rows={rows}
        className="claims-breakdown-table"
        headerBgColor="secondary"
        headerTextColor="primary"
      />
    </div>
  );
};

export default ClaimsBreakDownTable;
